"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabRouter = void 0;
const tabs_1 = require("client/components/material/tabs");
const router_1 = require("client/components/router/router");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
let TabRouter = class TabRouter extends router_1.Router {
    constructor(props, withPadding = false) {
        super(props);
        this.tabs = [];
        this.withPadding = false;
        this.value = 0;
        this.show = true;
        this.visibleTabs = () => this.tabs.filter(tab => !tab.shouldShow || tab.shouldShow());
        this.onAction = () => {
            const visibleTabs = this.visibleTabs();
            const index = this.route
                ? visibleTabs.findIndex(tab => (this.route && this.route.name) === tab.name)
                : 0;
            this.value = index < 0 ? 0 : index;
        };
        this.onChange = (event, value) => {
            const tab = this.visibleTabs()[value];
            if (!tab)
                return;
            let name = tab.name;
            name = typeof name === "string" ? name : name();
            router_1.RouteManager.transitionTo(name);
        };
        this.showTabs = (show = true) => {
            this.show = show;
        };
        this.withPadding = withPadding;
    }
    componentWillMount() {
        super.componentWillMount();
        router_1.RouteManager.addStateListener(this.onAction);
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        router_1.RouteManager.removeStateListener(this.onAction);
    }
    addTab(label, name, path, component, shouldShow) {
        super.addRoute(name, path, component);
        this.tabs.push({
            label,
            name,
            path,
            component,
            shouldShow
        });
    }
    render() {
        return (React.createElement("div", null,
            this.show && (React.createElement(tabs_1.MaterialTabs, { onAction: this.onAction, onChange: this.onChange, tabs: this.visibleTabs().map(tab => ({
                    label: tab.label
                })), value: this.value, padding: this.withPadding })),
            this.component));
    }
};
__decorate([
    mobx_1.observable
], TabRouter.prototype, "value", void 0);
__decorate([
    mobx_1.observable
], TabRouter.prototype, "show", void 0);
TabRouter = __decorate([
    mobx_react_1.observer
], TabRouter);
exports.TabRouter = TabRouter;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/router/tab-router.tsx
// module id = 1926
// module chunks = 0 1 2